"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class NavBarMenuItemComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.itemStyle = {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "3px",
            paddingBottom: "3px",
            whiteSpace: "nowrap",
        };
        this.handleOnMouseEnter = () => {
            this.setState({ hover: true });
        };
        this.handleOnMouseLeave = () => {
            this.setState({ hover: false });
        };
        this.state = { hover: false };
    }
    render() {
        const background = this.state.hover ? "rgba(47,164,231,1)" : "white";
        const color = this.state.hover ? "white" : "#333";
        const style = { background, color };
        return (React.createElement("div", { onClick: this.props.onClick, style: Object.assign({}, this.itemStyle, style), onMouseEnter: this.handleOnMouseEnter, onMouseLeave: this.handleOnMouseLeave }, this.props.content));
    }
}
class NavBarMenu extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.containerStyle = {
            position: "absolute",
            background: "white",
            top: (this.props.height + 1) + "px",
            right: 0,
            left: "auto",
            paddingTop: "5px",
            paddingBottom: "5px",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
            minWidth: "100%",
            boxShadow: "rgba(0,0,0,0.2) 0 6px 20px ",
            zIndex: 10000
        };
    }
    render() {
        return (React.createElement("div", { style: this.containerStyle }, this.props.items
            .filter(x => x)
            .map((x, i) => !(x.visible == false) && React.createElement(NavBarMenuItemComponent, { content: x.content, key: i, onClick: x.onClick }))));
    }
}
exports.NavBarMenu = NavBarMenu;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/navbar/menu.js
// module id = 2243
// module chunks = 0